import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import { useEmailsDirectory } from './context/EmailsDirProvider';

const EmailsDirToolBar = ({ tab }: { tab: 'clients' | 'others' }) => {
    const { t } = useTranslation('EmailsDir');
    const { search, setSearch, editing, setEditing, busy, entriesLoading } = useEmailsDirectory();
    return (
        <div className="mb-3">
            {tab === 'others' && !editing && <div className="d-flex justify-content-end mb-3">
                <Button type="button" size="sm" variant="primary" disabled={busy || entriesLoading} onClick={() => setEditing('new')}><SolarIcon name="plus" className="me-2" />{t('add')}</Button>
            </div>}
            <Form.Control aria-label={t('search')} placeholder={t('search')} value={search[tab]} onChange={(event) => setSearch((prev) => ({ ...prev, [tab]: event.target.value }))} />
        </div>
    );
};

export default EmailsDirToolBar;
